var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_vm._t(_vm.current)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }